
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sendungen/[show]",
      function () {
        return require("private-next-pages/sendungen/[show].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sendungen/[show]"])
      });
    }
  